export const brandContainer = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
};

export const bcmeaLogo = {
  width: { xs: "200px", md: "400px" }
}

export const ilwuLogo = {
  width: { xs: "50px", marginLeft: '15px' }
}